import React from "react";
import {
  MDBModal,
  MDBModalBody,
  MDBIcon,
} from "mdbreact";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { useTranslation } from "react-i18next";
import styles from "./WarningModal.module.scss";

const WarningModal = ({ isOpen, handleToggle, onConfirmation, ...props }) => {
  const { t } = useTranslation();
  const title = props.title || "Delete document?";
  const message =
    props.message ||
    "This document will be removed from the staff profile. This action cannot be undone.";

  return (
    <MDBModal
      isOpen={isOpen}
      toggle={handleToggle}
      centered
      disableBackdrop
      className={styles.warningModal}
    >
      <MDBModalBody className={styles.warningBody}>
        <button
          type="button"
          className={styles.closeButton}
          aria-label={t("Close")}
          onClick={handleToggle}
        >
          <MDBIcon icon="times" />
        </button>
        <div className={styles.warningIcon}>
          <DeleteOutlineIcon />
        </div>
        <div className={styles.warningCopy}>
          <h3>{t(title)}</h3>
          <p>{t(message)}</p>
        </div>
        <div className={styles.warningActions}>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={handleToggle}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className={styles.dangerButton}
            onClick={() => {
              onConfirmation();
              handleToggle();
            }}
          >
            {t("Delete")}
          </button>
        </div>
      </MDBModalBody>
    </MDBModal>
  );
};

export default WarningModal;
